import { render, staticRenderFns } from "./Latestbroadcast.vue?vue&type=template&id=2834ef54&scoped=true"
import script from "./Latestbroadcast.vue?vue&type=script&lang=js"
export * from "./Latestbroadcast.vue?vue&type=script&lang=js"
import style0 from "./Latestbroadcast.vue?vue&type=style&index=0&id=2834ef54&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2834ef54",
  null
  
)

export default component.exports